export enum PurposesEnum {
  residential = 'RESIDENTIAL',
  commercial = 'COMMERCIAL',
}
